export default __webpack_public_path__ + "static/media/e3.14960a3a.png";